// Shared branding options: curated enterprise palettes + 4 design presets.
// "Corporate Gold" is the Aetria signature palette; teal remains available.
export const PALETTES = [
  { name: "Corporate Gold", primary: "#1E293B", accent: "#D4A017" },
  { name: "Slate & Teal", primary: "#1E293B", accent: "#0D9488" },
  { name: "Navy & Gold", primary: "#1E3A5F", accent: "#B45309" },
  { name: "Graphite & Emerald", primary: "#1F2937", accent: "#059669" },
  { name: "Midnight & Sky", primary: "#0F172A", accent: "#0284C7" },
  { name: "Ink & Crimson", primary: "#18181B", accent: "#BE123C" },
  { name: "Espresso & Copper", primary: "#292524", accent: "#C2410C" },
  { name: "Forest & Moss", primary: "#14532D", accent: "#65A30D" },
  { name: "Steel & Cobalt", primary: "#334155", accent: "#2563EB" },
];

export const PRESETS = [
  { id: "consulting", name: "Consulting", blurb: "Sharp corners, dense, slate — the flagship look" },
  { id: "modern", name: "Modern", blurb: "Softly rounded corners, lighter feel" },
  { id: "classic", name: "Classic Corporate", blurb: "Serif display headings, boxed cards" },
  { id: "minimal", name: "Minimal Light", blurb: "White sidebar, thin rules, single accent" },
];

// Static fallback mirror of the backend band table (billing/config.py
// DEFAULT_BANDS) — used only while /api/signup/pricing loads or if it fails.
export const FALLBACK_BANDS = [
  { id: "launch", name: "Launch", employee_cap: 5, qar: 199, usd: 55, per_employee: 40, per_employee_usd: 11, contact: false },
  { id: "micro", name: "Micro", employee_cap: 10, qar: 349, usd: 96, per_employee: 35, per_employee_usd: 10, contact: false },
  { id: "starter", name: "Starter", employee_cap: 15, qar: 499, usd: 137, per_employee: 33, per_employee_usd: 9, contact: false },
  { id: "team", name: "Team", employee_cap: 35, qar: 1049, usd: 288, per_employee: 30, per_employee_usd: 8, contact: false },
  { id: "growth", name: "Growth", employee_cap: 45, qar: 1299, usd: 357, per_employee: 29, per_employee_usd: 8, contact: false },
  { id: "business", name: "Business", employee_cap: 50, qar: 1399, usd: 384, per_employee: 28, per_employee_usd: 8, contact: false },
  { id: "scale", name: "Scale", employee_cap: 200, qar: 4499, usd: 1236, per_employee: 22, per_employee_usd: 6, contact: false },
  { id: "corporate", name: "Corporate", employee_cap: 300, qar: 5999, usd: 1648, per_employee: 20, per_employee_usd: 5, contact: false },
  { id: "enterprise", name: "Enterprise", employee_cap: 500, qar: 8999, usd: 2472, per_employee: 18, per_employee_usd: 5, contact: false },
  { id: "enterprise_plus", name: "Enterprise+", employee_cap: null, qar: null, usd: null, per_employee: null, per_employee_usd: null, contact: true },
];

// First band whose cap covers the headcount; above the top cap -> contact band.
export const matchBand = (bands, count) =>
  bands.find((b) => !b.contact && b.employee_cap >= count)
  || bands.find((b) => b.contact)
  || bands[bands.length - 1];
